module.exports = __webpack_public_path__ + "img/logo.365f029b.png";